import { Handler } from "@insite/client-framework/HandlerCreator";
import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { Cart } from "@insite/client-framework/Services/CartService";
import { chain, SetShipToForEditing } from "@insite/client-framework/Store/Pages/CheckoutShipping/Handlers/SetUseBillingAddress";
import { ShipToModel } from "@insite/client-framework/Types/ApiModels";

type HandlerType = Handler<
    {
        useBillingAddress: boolean;
    },
    {
        cart: Cart;
        shipTosForBillTo: ShipToModel[];
        shipToForEditing: ShipToModel;
    }
>;

export const CustomSetShipToForEditing: HandlerType = props => {
    const {
        getState,
        parameter: { useBillingAddress },
        cart,
        shipTosForBillTo,
    } = props;
    const { isGuestOrder } = cart;

    if (useBillingAddress) {
        const billToAsShipTo = shipTosForBillTo.find(o => o.id === cart.billToId);
        props.shipToForEditing = billToAsShipTo!;
    } else {
        const {
            pages: {
                checkoutShipping: { lastSelectedShippingAddress },
            },
            data: {
                billTos: { byId }
            }
        } = getState();
        let shipTo: ShipToModel | undefined = lastSelectedShippingAddress;
        if (shipTo.id === cart.billToId) {
            shipTo = shipTosForBillTo.find(o => o.isDefault);
            if (!shipTo) {
                shipTo = shipTosForBillTo.find(o => !o.isNew && !o.oneTimeAddress && o.id !== cart.billToId);
            }
            if (isGuestOrder && cart.billToId) {
                const billToAsShipTo = byId[cart.billToId];
                shipTo = {
                    ...billToAsShipTo, 
                    isNew: false,
                    isVmiLocation: false,
                    oneTimeAddress: false,
                } as ShipToModel;
            }
            if (!shipTo) {
                throw new Error(
                    "No applicable shipto (e.g. one-time, billto) was found in the cart. At least one shipto must be available to allow editing.",
                );
            }
        }

        props.shipToForEditing = shipTo;
    }
};

replaceInChain(chain, SetShipToForEditing, CustomSetShipToForEditing);
